import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'property-skeleton',
  standalone: false,
  templateUrl: './property-skeleton.component.html',
  styleUrl: './property-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertySkeletonComponent {

}
